module.exports = __webpack_public_path__ + "static/img/noData.71d119e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/noData.png
// module id = KrUZ
// module chunks = 1